import {
  ISolution, ISolutionComposition, ISolutionCompositionData,
  ISolutionData,
  SOLUTION_NAME_MAX_LENGTH
} from './index'
import {
  Category,
  IService,
  IServiceData,
  Service
} from '../index'

export class Solution implements ISolution {
  readonly id?: number
  name: string
  total: number
  readiness_days?: number
  category?: Category
  service: IService[]

  constructor(data?: ISolutionData) {
    this.id = data?.id
    this.name = data?.name || ''
    this.service = data?.service.map((s: IServiceData) => new Service(s)) || []
    this.total = data?.total || this.service.reduce((sum: number, s: IService) => sum + s.total, 0)
    this.readiness_days = data?.readiness_days
    this.category = data?.category
  }

  validate(): boolean {
    return this.validateName() && this.validateTotal()
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= SOLUTION_NAME_MAX_LENGTH
  }

  validateTotal(): boolean {
    let total = this.total
    return !!total && total > 0
  }

  update(data?: ISolutionData) {
    this.name = data?.name || this.name
    data?.service?.forEach((item: IServiceData) => {
      this.service?.find((i: IService) => i.id === item.id)?.update(item);
    });
  }
}

export class SolutionComposition implements ISolutionComposition {
  consultation?: number;
  plan?: number;
  services: {
    [name: string]: number;
  }

  constructor(data?: ISolutionCompositionData) {
    this.services = {};
    const services = data?.services || {};
    Object.keys(services).forEach(key => {
      (this.services as any)[key] = services[key];
    });
    this.consultation = data?.consultation;
    this.plan = data?.plan;
  }
}
